export const RECORDING_TOAST_POSITION_STORAGE_KEY_PREFIX =
  'recordingToastPosition';
export const MAX_STORED_COORDINATE = 100000;

export const RECORDING_TOAST_VIEWPORT_MARGIN = 16;
export const RECORDING_TOAST_DEFAULT_LEFT = 32;
export const RECORDING_TOAST_DEFAULT_BOTTOM = 70;
export const RECORDING_TOAST_DEFAULT_WIDTH = 422;

export const VISUALIZER_BAR_COUNT = 12;
export const VISUALIZER_BAR_MIN_HEIGHT = 16;
export const VISUALIZER_BAR_MAX_HEIGHT = 128;
export const VISUALIZER_FRAME_INTERVAL_MS = 16;
export const VISUALIZER_MAX_AUDIO_LEVEL = 100;
export const VISUALIZER_AUDIO_LEVEL_HEIGHT_SCALE = 110;
export const VISUALIZER_RANDOM_HEIGHT_VARIATION = 24;
export const VISUALIZER_WAVE_AMPLITUDE = 0.4;
export const VISUALIZER_WAVE_INDEX_OFFSET = 0.8;
export const VISUALIZER_WAVE_TIME_DIVISOR = 50;

export const DICTATION_COUNTDOWN_TICK_MS = 1000;
export const DICTATION_COUNTDOWN_ENDING_SECONDS = 30;
